import * as React from "react";
const SvgX = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="m1.5 1.5 9 9m0-9-9 9" /></svg>;
export default SvgX;